export enum errorForgot {
	'EMAIL_NONE' = 'Please input your email!',
	'EMAIL_FORMAT' = 'Email not correct format!',
}
